import PageContainer from './PageContainer.jsx';
import Header from './header/Header.jsx';

function DefaultLayout({ children }) {
    return (
        <PageContainer>
            <Header />
            <main className="main-content">
                {children}
            </main>
        </PageContainer>
    );
}

export default DefaultLayout;